module.exports = __webpack_public_path__ + "static/media/Verda-HPT-Hi-Res-Logo.05ceb45f.jpg";